(function () {

  var WISHLIST_KEY = 'bd_wishlist';

  var grid =
    document.querySelector(
      '[data-bd-wishlist-grid]'
    );

  var emptyState =
    document.querySelector(
      '[data-bd-wishlist-empty]'
    );

  var loading =
    document.querySelector(
      '[data-bd-wishlist-loading]'
    );


  if (!grid) {
    return;
  }


  /* =========================================================
     WISHLIST STORAGE
     ========================================================= */

  function getWishlist() {

    try {

      var saved =
        JSON.parse(
          localStorage.getItem(
            WISHLIST_KEY
          ) || '[]'
        );


      return Array.isArray(saved)
        ? saved
        : [];

    } catch (err) {

      return [];

    }

  }


  function setWishlist(list) {

    try {

      localStorage.setItem(
        WISHLIST_KEY,
        JSON.stringify(list)
      );

    } catch (err) {
      /* Ignore storage errors */
    }


    window.dispatchEvent(
      new CustomEvent(
        'bd:wishlist:updated'
      )
    );

  }


  /* =========================================================
     HTML ESCAPE
     ========================================================= */

  function escapeHtml(value) {

    if (
      value === null ||
      value === undefined
    ) {
      return '';
    }


    return String(value)
      .replace(
        /&/g,
        '&amp;'
      )
      .replace(
        /</g,
        '&lt;'
      )
      .replace(
        />/g,
        '&gt;'
      )
      .replace(
        /"/g,
        '&quot;'
      )
      .replace(
        /'/g,
        '&#039;'
      );

  }


  /* =========================================================
     CLEAN PRODUCT DESCRIPTION
     ========================================================= */

  function cleanDescription(html) {

    if (!html) {
      return '';
    }


    var temp =
      document.createElement(
        'div'
      );


    temp.innerHTML = html;


    var text =
      temp.textContent ||
      temp.innerText ||
      '';


    return text
      .replace(
        /\s+/g,
        ' '
      )
      .trim();

  }


  /* =========================================================
     MONEY FORMAT
     ========================================================= */

  function formatMoney(cents) {

    if (
      window.Shopify &&
      typeof Shopify.formatMoney ===
        'function' &&
      window.theme_money_format
    ) {

      return Shopify.formatMoney(
        cents,
        window.theme_money_format
      );

    }


    var amount =
      Number(cents || 0) / 100;


    return (
      '₹' +
      amount.toLocaleString(
        'en-IN',
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      )
    );

  }


  /* =========================================================
     FIND BEST VARIANT
     ========================================================= */

  function getBestVariant(product) {

    if (
      !product ||
      !Array.isArray(
        product.variants
      ) ||
      !product.variants.length
    ) {

      return null;

    }


    /*
      Prefer an available variant.
      Otherwise use the first variant.
    */

    var availableVariant =
      product.variants.find(
        function (variant) {

          return (
            variant &&
            variant.available
          );

        }
      );


    return (
      availableVariant ||
      product.variants[0]
    );

  }


  /* =========================================================
     BUILD PRODUCT CARD
     ========================================================= */

  function buildCard(product) {

    var variant =
      getBestVariant(product);


    var available =
      !!(
        variant &&
        variant.available
      );


    var price =
      variant
        ? variant.price
        : product.price;


    var comparePrice =
      variant
        ? variant.compare_at_price
        : product.compare_at_price;


    var image =
      product.featured_image ||
      (
        product.images &&
        product.images[0]
      ) ||
      '';


    var title =
      product.title ||
      'Product';


    var description =
      cleanDescription(
        product.description ||
        product.body_html ||
        ''
      );


    /*
      Product URL.
    */

    var productUrl =
      '/products/' +
      encodeURIComponent(
        product.handle
      );


    var card =
      document.createElement(
        'article'
      );


    card.className =
      'bd-wish__card';


    card.setAttribute(
      'data-bd-wishlist-card',
      product.id
    );


    /* =====================================================
       PRICE HTML
       ===================================================== */

    var priceHtml =
      '<span class="bd-wish__card-current">' +
      formatMoney(price) +
      '</span>';


    if (
      comparePrice &&
      Number(comparePrice) >
        Number(price)
    ) {

      priceHtml =
        '<span class="bd-wish__card-compare">' +
        formatMoney(comparePrice) +
        '</span>' +
        priceHtml;

    }


    /* =====================================================
       DESCRIPTION HTML
       ===================================================== */

    var descriptionHtml =
      description
        ? (
          '<p class="bd-wish__card-desc">' +
          escapeHtml(
            description
          ) +
          '</p>'
        )
        : '';


    /* =====================================================
       IMAGE HTML
       ===================================================== */

    var imageHtml = '';


    if (image) {

      imageHtml =
        '<img' +
        ' src="' +
        escapeHtml(image) +
        '"' +
        ' alt="' +
        escapeHtml(title) +
        '"' +
        ' loading="lazy"' +
        ' width="600"' +
        ' height="750"' +
        '>' ;

    }


    /* =====================================================
       BUTTON
       ===================================================== */

    var addButtonText =
      available
        ? 'Add to Cart'
        : 'Sold Out';


    var variantId =
      variant
        ? variant.id
        : '';


    var disabled =
      available
        ? ''
        : ' disabled';


    /* =====================================================
       CARD HTML
       ===================================================== */

    card.innerHTML =

      '<a' +
      ' href="' +
      productUrl +
      '"' +
      ' class="bd-wish__card-media"' +
      ' aria-label="' +
      escapeHtml(title) +
      '"' +
      '>' +

        imageHtml +

      '</a>' +


      '<div class="bd-wish__card-info">' +


        '<a' +
        ' href="' +
        productUrl +
        '"' +
        ' class="bd-wish__card-title"' +
        '>' +

          escapeHtml(title) +

        '</a>' +


        descriptionHtml +


        '<p class="bd-wish__card-price">' +

          priceHtml +

        '</p>' +


        '<button' +
        ' type="button"' +
        ' class="bd-wish__card-add"' +
        ' data-bd-wishlist-add' +
        ' data-variant-id="' +
        escapeHtml(
          variantId
        ) +
        '"' +
        disabled +
        '>' +

          addButtonText +

        '</button>' +


        '<button' +
        ' type="button"' +
        ' class="bd-wish__card-remove"' +
        ' data-bd-wishlist-remove' +
        ' data-product-id="' +
        escapeHtml(
          product.id
        ) +
        '"' +
        '>' +

          'Remove' +

        '</button>' +


      '</div>';


    return card;

  }


  /* =========================================================
     EMPTY STATE
     ========================================================= */

  function showEmptyState() {

    if (emptyState) {

      emptyState.hidden = false;

      emptyState.classList.add(
        'is-visible'
      );

    }

  }


  function hideEmptyState() {

    if (emptyState) {

      emptyState.hidden = true;

      emptyState.classList.remove(
        'is-visible'
      );

    }

  }


  /* =========================================================
     LOADING STATE
     ========================================================= */

  function showLoading() {

    if (loading) {

      loading.classList.add(
        'is-visible'
      );

    }

  }


  function hideLoading() {

    if (loading) {

      loading.classList.remove(
        'is-visible'
      );

    }

  }


  /* =========================================================
     RENDER WISHLIST
     ========================================================= */

  function render() {

    var list =
      getWishlist();


    grid.innerHTML = '';


    /*
      No wishlist items.
    */

    if (!list.length) {

      hideLoading();

      showEmptyState();

      return;

    }


    hideEmptyState();

    showLoading();


    /*
      Fetch every saved product.
    */

    var fetches =
      list.map(
        function (entry) {

          if (
            !entry ||
            !entry.handle
          ) {

            return Promise.resolve(
              null
            );

          }


          return fetch(
            '/products/' +
            encodeURIComponent(
              entry.handle
            ) +
            '.js'
          )

            .then(
              function (res) {

                if (!res.ok) {

                  return null;

                }


                return res.json();

              }
            )

            .catch(
              function () {

                return null;

              }
            );

        }
      );


    Promise.all(fetches)
      .then(
        function (products) {

          grid.innerHTML = '';


          var validProducts =
            products.filter(
              function (product) {

                return (
                  product !==
                  null
                );

              }
            );


          /*
            If all saved products
            are invalid/deleted.
          */

          if (
            !validProducts.length
          ) {

            showEmptyState();

            hideLoading();

            return;

          }


          validProducts.forEach(
            function (product) {

              grid.appendChild(
                buildCard(
                  product
                )
              );

            }
          );


          hideLoading();


          bindCardEvents();

        }
      )

      .catch(
        function () {

          hideLoading();

          /*
            Keep the page usable even
            if a fetch unexpectedly fails.
          */

          if (!grid.children.length) {
            showEmptyState();
          }

        }
      );

  }


  /* =========================================================
     BIND CARD EVENTS
     ========================================================= */

  function bindCardEvents() {


    /* =====================================================
       ADD TO CART
       ===================================================== */

    grid
      .querySelectorAll(
        '[data-bd-wishlist-add]'
      )
      .forEach(
        function (btn) {

          btn.addEventListener(
            'click',
            function () {

              var variantId =
                btn.getAttribute(
                  'data-variant-id'
                );


              if (!variantId) {
                return;
              }


              var originalText =
                btn.textContent;


              btn.disabled = true;

              btn.textContent =
                'Adding…';


              fetch(
                '/cart/add.js',
                {
                  method: 'POST',

                  headers: {
                    'Content-Type':
                      'application/json'
                  },

                  body:
                    JSON.stringify(
                      {
                        items: [
                          {
                            id:
                              Number(
                                variantId
                              ),

                            quantity: 1
                          }
                        ]
                      }
                    )
                }
              )

                .then(
                  function (res) {

                    if (!res.ok) {

                      throw new Error(
                        'Add to cart failed'
                      );

                    }


                    return res.json();

                  }
                )

                .then(
                  function () {

                    btn.textContent =
                      'Added!';

                    btn.classList.add(
                      'is-added'
                    );


                    window.dispatchEvent(
                      new CustomEvent(
                        'bd:cart:updated'
                      )
                    );


                    /*
                      Also trigger Shopify
                      cart refresh event
                      if theme supports it.
                    */

                    document.dispatchEvent(
                      new CustomEvent(
                        'cart:refresh'
                      )
                    );


                    setTimeout(
                      function () {

                        btn.textContent =
                          originalText;

                        btn.classList.remove(
                          'is-added'
                        );

                        btn.disabled =
                          false;

                      },
                      1600
                    );

                  }
                )

                .catch(
                  function () {

                    btn.textContent =
                      'Try Again';

                    btn.disabled =
                      false;

                  }
                );

            }
          );

        }
      );


    /* =====================================================
       REMOVE FROM WISHLIST
       ===================================================== */

    grid
      .querySelectorAll(
        '[data-bd-wishlist-remove]'
      )
      .forEach(
        function (btn) {

          btn.addEventListener(
            'click',
            function () {

              var productId =
                btn.getAttribute(
                  'data-product-id'
                );


              var current =
                getWishlist();


              var updated =
                current.filter(
                  function (entry) {

                    return (
                      String(
                        entry.id
                      ) !==
                      String(
                        productId
                      )
                    );

                  }
                );


              setWishlist(
                updated
              );


              var card =
                btn.closest(
                  '[data-bd-wishlist-card]'
                );


              if (card) {

                card.style.opacity =
                  '0';

                card.style.transform =
                  'translateY(6px)';

                setTimeout(
                  function () {

                    card.remove();


                    /*
                      If there are no
                      cards remaining,
                      show empty state.
                    */

                    if (
                      !grid.children.length
                    ) {

                      showEmptyState();

                    }

                  },
                  180
                );

              }

            }
          );

        }
      );

  }


  /* =========================================================
     INITIAL RENDER
     ========================================================= */

  render();


  /* =========================================================
     LISTEN FOR WISHLIST CHANGES
     ========================================================= */

  window.addEventListener(
    'bd:wishlist:updated',
    function () {

      /*
        Don't unnecessarily re-render
        when current page already
        handled the remove action.
      */

    }
  );


  /* =========================================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (
        event.target &&
        event.target.querySelector(
          '[data-bd-wishlist-grid]'
        )
      ) {

        /*
          Shopify dynamically loaded
          wishlist section.
        */

        grid =
          event.target.querySelector(
            '[data-bd-wishlist-grid]'
          );

        emptyState =
          event.target.querySelector(
            '[data-bd-wishlist-empty]'
          );

        loading =
          event.target.querySelector(
            '[data-bd-wishlist-loading]'
          );

        render();

      }

    }
  );

})();